export default __webpack_public_path__ + "static/media/shoes.58740db1.webp";